import { useEffect } from 'react'

import { useAuth } from 'hooks/UseAuth'
import { useWebsocketConnection } from 'providers/WebsocketProvider'

const REGISTRATION_CHANNEL = 'RegistrationChannel'

enum RegistrationChannelPayloadAction {
  SetOnboardingDocPath = 'set_onboarding_doc_path',
}

interface PayloadData {
  onboarding_doc_path: string
}

interface RegistrationChannelPayload {
  action: RegistrationChannelPayloadAction
  data: PayloadData
}

interface Props {
  setOnboardingDocPath: React.Dispatch<React.SetStateAction<string | undefined>>
  setWorkspaceSeeded: React.Dispatch<React.SetStateAction<boolean>>
}

export const useRegistrationChannel = ({ setOnboardingDocPath, setWorkspaceSeeded }: Props) => {
  const auth = useAuth()
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!auth || !websocketConnection) return

    const subscription = websocketConnection.subscriptions.create(
      { channel: REGISTRATION_CHANNEL, user_id: auth.id },
      {
        received({ action, data }: RegistrationChannelPayload) {
          if (action === RegistrationChannelPayloadAction.SetOnboardingDocPath && data.onboarding_doc_path) {
            setOnboardingDocPath(data.onboarding_doc_path)
            setWorkspaceSeeded(true)
          }
        },
      },
    )
    return () => subscription.unsubscribe()
  }, [auth, websocketConnection, setOnboardingDocPath, setWorkspaceSeeded])
}
